<div *ngFor="let field of field?.fieldGroup; let i = index" [attr.data-testing-id]="'oci-config-line-' + i">
  <formly-field [field]="field" />
</div>
